
export default {
    name: 'SiteEmpty',
    props: {
        icon: {
            type: Object,
            default() {
                return null;
            },
        },
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
    },
};

